/*
 *   Copyright (c) 2021 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { UserService } from '../../common-services/user/user.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SlotService {
  
  public isSlotMasterInEditMode;
  public slotMaster;
  public daySlotMaster;
  public daySlotMastersList;

  URL = {
    daySlotMaster: '/daySlotMaster',
    slotmaster: '/slotmaster',
    calenderSlotMaster: '/calenderSlotMaster',
    listProductCategories: '/listProductCategories',
    businessUsers: '/businessUsers',
    daySlotMasterMassUpdate: '/daySlotMasterMassUpdate',
    slotMasterMassUpdate: '/slotMasterMassUpdate',
    appointment: '/appointment',
    contacts: '/contacts',
    getAppointments: '/appointments',
    getSlotMasterDetails: '/getSlotMasterAppointments',
    cloneDaySlotMaster: '/cloneDaySlotMaster',
    createOrder: '/couponTransaction',
    coupon: '/coupon',
    checkCouponTransaction : '/checkCouponTransaction',
    getAppointmentSalesperson : '/getAppointmentSalesperson'
  };

  prodServerUrl = environment.config.prodServerUrl;

  constructor(private http: HttpClient, private userService: UserService) { }

  getDaySlotMasters(businessUnitId?) {
    let httpParams = new HttpParams();
    if (businessUnitId) {
      httpParams = httpParams.set('businessUnitId', businessUnitId);
    } else {
      httpParams = httpParams.set('businessUnitId', this.userService.currentBusinessUnitId);
    }
    return this.http.get<any>(this.prodServerUrl + this.URL.daySlotMaster, {params: httpParams});
  }

  createDaySlotMaster(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.daySlotMaster, data);
  }

  createSlotMaster(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.slotmaster, data);
  }

  getProductCategories() {
   return this.http.get<any>(this.prodServerUrl + this.URL.listProductCategories);
  }

  getBusinessUsers() {
    return this.http.get<any>(this.prodServerUrl + this.URL.businessUsers);
  }

  stringDateFormat(date?) {
    let givenDate;
    if (date) {
      givenDate = date;
    } else {
      givenDate = new Date();
    }
    const today = new Date(givenDate);
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
  }

  getCalenderDaySlotMasters(bUnitId, fromDate, toDate, status?, isSummery?, salesPersons?) {
    if(salesPersons && !salesPersons.length) {
    if (bUnitId ) {
      let httpParams = new HttpParams();
      httpParams = httpParams.set('businessUnitId', bUnitId);
      if(fromDate) {
        httpParams = httpParams.set('fromDate', this.stringDateFormat(fromDate).toString());
        httpParams = httpParams.set('toDate', this.stringDateFormat(toDate).toString());
      } else {
        httpParams = httpParams.set('isToday', 'true');
      }
      if(status) {
        httpParams = httpParams.set('isStatus', status);
      }
      if(isSummery) {
        httpParams = httpParams.set('isSummery', 'true');
      }
      return this.http.get<any>(this.prodServerUrl + this.URL.getAppointments, {params: httpParams});
    }
  } else {
      let url = "?businessUnitId=" + bUnitId + "&fromDate=" + this.stringDateFormat(fromDate).toString() +
        "&toDate=" + this.stringDateFormat(toDate).toString();
      if (status) {
        url += "&isStatus=" + status;
      }
      if (isSummery) {
        url += "&isSummery=" + true;
      }
      return this.http.post<any>(this.prodServerUrl + this.URL.getAppointmentSalesperson + url, { salespersons: salesPersons });
    }
  }

  createCalenderDaySlotMaster(data) {
    data['businessUnitId'] = this.userService.currentBusinessUnitId;
    return this.http.post<any>(this.prodServerUrl + this.URL.calenderSlotMaster, data);
  }

  updateDaySlotMaster(data) {
    return this.http.put<any>(this.prodServerUrl + this.URL.daySlotMaster, data);
  }

  massUpdateDaySlotMaster(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.daySlotMasterMassUpdate, data);
  }

  updateSlotMaster(data) {
    return this.http.put<any>(this.prodServerUrl + this.URL.slotmaster, data);
  }
  massUpdateSlotMaster(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.slotMasterMassUpdate, data);
  }


  createAppointment(data) {
    data['isWhiteShopB2CUser'] = 'true';
    return this.http.post<any>(this.prodServerUrl + this.URL.getAppointments, data);    
  }

  createContact(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.contacts, data);
  }

  getSlotMasterDetails(data) {
    console.log(data)
    let httpParams = new HttpParams();
    httpParams = httpParams.set('date', data.date);
    httpParams = httpParams.set('slotMasterId', data._id);
    httpParams = httpParams.set('fromTime', data.fromTime);
    httpParams = httpParams.set('toTime', data.toTime);
    return this.http.get<any>(this.prodServerUrl + this.URL.getSlotMasterDetails, {params: httpParams});
  }

  getBookedAppointments(data) {
    console.log(data)
    let httpParams = new HttpParams();
    httpParams = httpParams.set('businessUnitId', this.userService.currentBusinessUnitId);
    httpParams = httpParams.set('fromDate', data.fromDate);
    httpParams = httpParams.set('toDate', data.toDate); 
    httpParams = httpParams.set('isBooked', 'true');     
    httpParams = httpParams.set('type', 'valuChain');     
    return this.http.get<any>(this.prodServerUrl + this.URL.appointment, {params: httpParams});
  }
  cloneSlots(daySlotMasterId) {
    const httpParams = new HttpParams().set('_id', daySlotMasterId.toString());
    return this.http.get<any>(this.prodServerUrl + this.URL.cloneDaySlotMaster, {params: httpParams});
  }

  getSummeryData(bUnit, from, to) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('businessUnitId', bUnit);
    httpParams = httpParams.set('fromDate', from);
    httpParams = httpParams.set('toDate', to); 
    httpParams = httpParams.set('isSummary', 'true');     
    return this.http.get<any>(this.prodServerUrl + this.URL.appointment, {params: httpParams});
  }

  createOrder(data) {
    return this.http.post<any>(this.prodServerUrl + this.URL.createOrder, data);
  }

  verifyCoupon(data) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('coupon', data);
    return this.http.get<any>(this.prodServerUrl + this.URL.coupon, {params: httpParams});
  }

  checkCouponTransaction(data) {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('appointment', data);
    return this.http.get<any>(this.prodServerUrl + this.URL.checkCouponTransaction, {params: httpParams});
  }
}

